/**
 * Available custom material theme identifier.
 */
export enum Theme {
  BLUE = 'blue-theme.css',
  ORANGE = 'orange-theme.css',
  RED = 'red-theme.css',
  DEV = 'dev-theme.css',
  QUAL = 'qual-theme.css',
  PROD = 'prod-theme.css',
}
